module.exports = __webpack_public_path__ + "img/Splash.8f190def.png";